"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const button_dew_svg_1 = __importDefault(require("@@/assets/svgs/button_dew.svg"));
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1(props) {
    const { isDemandSurvey, isClosed } = props, buttonProps = __rest(props, ["isDemandSurvey", "isClosed"]);
    if (isClosed) {
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '56px',
                padding: '0 16px',
                borderRadius: '12px',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                color: 'rgba(0, 0, 0, 0.3)',
                backgroundColor: 'white',
                lineHeight: '22px',
                fontSize: '20px',
                fontWeight: 'bold',
                fontFamily: 'Maplestory, -apple-system, BlinkMacSystemFont, "Spoqa Han Sans", "Spoqa Han Sans JP", sans-serif',
                '*': { fontFamily: 'inherit' },
                textAlign: 'center',
                wordBreak: 'keep-all',
            } }, { children: props.children })));
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            position: 'relative',
            display: 'flex',
            alignItems: 'flex-end',
            width: '100%',
            height: '56px',
            '> button': {
                height: '56px',
                border: '2px solid #583111',
                borderRadius: '12px',
                fontSize: '20px',
                fontWeight: 'bold',
                fontFamily: 'Maplestory, -apple-system, BlinkMacSystemFont, "Spoqa Han Sans", "Spoqa Han Sans JP", sans-serif',
                '*': { fontFamily: 'inherit' },
                color: isDemandSurvey ? '#583111' : 'white',
                backgroundColor: isDemandSurvey ? '#ffe240' : '#ff8f44',
                boxShadow: isDemandSurvey
                    ? 'inset 0px -3px 0px #a17322, inset 3px 3px 0px #fff8bb'
                    : 'inset 0px -3px 0px #c6501e, inset 2px 2px 0px #ffd0b0',
                transition: 'unset',
                '&:hover': {
                    backgroundColor: isDemandSurvey ? '#ffe240' : '#ff8f44',
                },
                '&:active': {
                    height: '54px',
                    border: '2px solid rgba(88, 49, 17, 0.4)',
                    color: 'rgba(88, 49, 17, 0.4)',
                    backgroundColor: isDemandSurvey ? '#ffee8e' : '#ffbd90',
                    boxShadow: isDemandSurvey ? 'inset 3px 3px 0px #fff8bb' : 'inset 2px 2px 0px #ffd0b0',
                },
            },
            '.Mui-disabled': {
                color: `${isDemandSurvey ? '#583111' : 'white'} !important`,
            },
            '.button_dew_svg': {
                position: 'absolute',
                top: '3px',
                left: '3px',
            },
            'button:active + .button_dew_svg': {
                top: '6px',
                left: '4px',
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ fullWidth: true, disableRipple: true }, buttonProps)), (0, jsx_runtime_1.jsx)(button_dew_svg_1.default, { className: "button_dew_svg" })] })));
}
exports.default = default_1;
